// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2otbk","map":"map-19kx8"};